module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f005-01.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Hand-knitted mittens have long been popular accessories to make for babies and small children. Whether they are a gift for a newborn, or a fun present for an older toddler, they make great projects to knit and give to friends and family.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The mittens are easy to make, use very little yarn, and are a good way to use up oddments or leftover yarn in your stash. They are quick enough to knit as the little one gets bigger, or if you would like to replace lost ones.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have designed 20 pairs of mittens in three different sizes: 0–3 months, 3–6 months and 6–12 months old, all of which are suitable for both boys and girls, and cover a wide variety of techniques and styles. These include texture, cable, lace, Fair Isle, intarsia and embroidery – so there’s something for everyone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The smaller pairs of mitts without thumbs need only simple decreasing, so can be made easily by beginners looking for a light and uncomplicated project. The largest mitten size has incorporated thumbs, and instructions for these are included separately in the patterns.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-t"
  }, [_vm._v("Happy knitting!")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f006-01.jpg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f007-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebd71e74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Introduction.vue
// module id = 75
// module chunks = 0